// adding slugify function instead of entire npm package
function slugify (string) {
  const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
  const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
  const p = new RegExp(a.split('').join('|'), 'g')

  return string.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

function changeHeaderLogoLink () {
  const headerLink = document.querySelector('.site-header__logo-link')
  if (!headerLink) return
  headerLink.href = 'https://www.plutobooks.com/'
}

function cartActions () {
  if (window.theme.settings.template !== 'cart') return
  const cartText = document.querySelector('.section-header')
  const continueShoppingLink = cartText.querySelector('a')
  if (continueShoppingLink) {
    continueShoppingLink.href = 'https://www.plutobooks.com/books'
  }
  const cartRows = document.querySelectorAll('.cart__row')
  cartRows.forEach(row => {
    const productTitleLink = row.querySelector('.cart__product-name')
    const productImageLink = row.querySelector('.cart__image')
    const productLinks = [productTitleLink, productImageLink]
    const isbn = row.dataset.isbn || null
    if (!isbn) return
    const newLink = `https://www.plutobooks.com/${isbn}/${slugify(productTitleLink.innerText)}`
    productLinks.forEach(link => {
      link.href = newLink
      link.target = '_blank'
    })
  })
}

function customFunctions () {
  changeHeaderLogoLink()
  cartActions()
}

module.exports = { customFunctions }
